export default __webpack_public_path__ + "static/media/Outfit-SemiBold.0458369a.ttf";